
              import { defineAsyncComponent } from 'vue'
              import Container from './app/render/components/devlayout/Container/LayoutContainer.vue'
import Image from './app/render/components/devtest/Image/Image.vue'
import SharedNodeRef from './app/render/components/generic/SharedNodeRef/SharedNodeRef.vue'
import Text from './app/render/components/devtest/Text/Text.vue'
import StyledContainer from './app/render/components/devlayout/StyledContainer/StyledContainer.vue'
import CTA from './app/render/components/buttons/CTAButton/CTAButton.vue'
import StickyContainer from './app/render/components/devlayout/StickyContainer/StickyContainer.vue'
import PrimerCheckout from './app/render/components/devtest/PrimerCheckout/PrimerCheckout.vue'
import Timer from './app/render/components/devtest/Timer/Timer.vue'
import ColumnsOrRows from './app/render/components/devlayout/ColumnsOrRows/ColumnsOrRows.vue'
import OfferSelect from './app/render/components/devtest/OfferSelectComponent/OfferSelectComponent.vue'
import Carousel from './app/render/components/devlayout/Carousel/Carousel.vue'
import EmailInput from './app/render/components/devtest/EmailInput/EmailInput.vue'
import OptionSingleSelect from './app/render/components/devtest/OptionSingleSelect/OptionSingleSelect.vue'
import PageBackground from './app/render/components/devlayout/PageBackground/PageBackground.vue'
import ProgressDonut from './app/render/components/devtest/ProgressDonut/ProgressDonut.vue'
import IconList from './app/render/components/devtest/IconList/IconList.vue'
import OptionMultiSelect from './app/render/components/devtest/OptionMultiSelect/OptionMultiSelect.vue'
import AgeInput from './app/render/components/devtest/AgeInput/AgeInput.vue'
import GoalLineChart from './app/render/components/devtest/GoalLineChart/GoalLineChart.vue'
import TextInput from './app/render/components/devtest/TextInput/TextInput.vue'
import MeasurementSwitcher from './app/render/components/devtest/MeasurementSwitcher/MeasurementSwitcher.vue'
import WeightInput from './app/render/components/devtest/WeightInput/WeightInput.vue'
import HeightInput from './app/render/components/devtest/HeightInput/HeightInput.vue'
import SelectionList from './app/render/components/devtest/SelectionList/SelectList.vue'
import SavedCard from './app/render/components/devtest/SavedCard/SavedCard.vue'
import SpeechBubble from './app/render/components/devlayout/SpeechBubble/SpeechBubble.vue'
import SplitBackground from './app/render/components/devlayout/SplitBackground/SplitBackground.vue'
import ComponentSlot from './app/render/components/generic/ComponentSlot/ComponentSlot.vue'
import ProgressBarPOC from './app/render/components/devtest/ProgressBarPOC/ProgressBarPOC.vue'
              export default {
                'Container': { component: Container },
'Image': { component: Image },
'SharedNodeRef': { component: SharedNodeRef },
'Text': { component: Text },
'StyledContainer': { component: StyledContainer },
'CTA': { component: CTA },
'StickyContainer': { component: StickyContainer },
'PrimerCheckout': { component: PrimerCheckout },
'Timer': { component: Timer },
'ColumnsOrRows': { component: ColumnsOrRows },
'OfferSelect': { component: OfferSelect },
'Carousel': { component: Carousel },
'EmailInput': { component: EmailInput },
'OptionSingleSelect': { component: OptionSingleSelect },
'PageBackground': { component: PageBackground },
'ProgressDonut': { component: ProgressDonut },
'IconList': { component: IconList },
'OptionMultiSelect': { component: OptionMultiSelect },
'AgeInput': { component: AgeInput },
'GoalLineChart': { component: GoalLineChart },
'TextInput': { component: TextInput },
'MeasurementSwitcher': { component: MeasurementSwitcher },
'WeightInput': { component: WeightInput },
'HeightInput': { component: HeightInput },
'SelectionList': { component: SelectionList },
'SavedCard': { component: SavedCard },
'SpeechBubble': { component: SpeechBubble },
'SplitBackground': { component: SplitBackground },
'ComponentSlot': { component: ComponentSlot },
'ProgressBarPOC': { component: ProgressBarPOC }
              }
            